var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLicense = function SvgLicense(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.69 2.209h6.26l1.19 1.19v5.8h-1V3.814l-.604-.604H5.104l-.604.604v7.974l.604.604h3.521v1H4.69l-1.19-1.19V3.4l1.19-1.19Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.522 6.25h4.608v-.9H5.522v.9ZM10.13 7.35v.9H5.51v-.9h4.62ZM8.661 10.25H5.51v-.9H8.66v.9ZM12.62 14.125V10h-3v4.125h.44l1.06-.697 1.06.697h.44Z",
    fill: "currentColor"
  })));
};
export default SvgLicense;